import { render } from "./MPhoneNumber.vue?vue&type=template&id=bbcc04ac"
import script from "./MPhoneNumber.vue?vue&type=script&lang=js"
export * from "./MPhoneNumber.vue?vue&type=script&lang=js"

import "./MPhoneNumber.vue?vue&type=style&index=0&id=bbcc04ac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__